module.exports = __webpack_public_path__ + "static/feature-share-70da2e7401a2d3985f4d5cf66e564384.mp4";